import { googleApi } from '@/admin/api/google';
import { queryOptions } from '@tanstack/react-query';

export const googleStatusQuery = () =>
	queryOptions({
		queryKey: ['google-status'] as const,
		queryFn: googleApi.getStatus,
		staleTime: 60_000,
		gcTime: 5 * 60_000,
		refetchOnWindowFocus: false,
	});

export const googleCredentialsQuery = () =>
	queryOptions({
		queryKey: ['google-credentials'] as const,
		queryFn: googleApi.getCredentials,
		staleTime: 5 * 60_000,
		gcTime: 10 * 60_000,
		refetchOnWindowFocus: false,
	});
